import { render, staticRenderFns } from "./DatasetView.vue?vue&type=template&id=b241cfb0&"
import script from "./DatasetView.vue?vue&type=script&lang=js&"
export * from "./DatasetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports